import { createGlobalStyle } from 'styled-components';
import poppinsBold from '../../assets/fonts/Poppins-Bold.otf';
import poppinsLight from '../../assets/fonts/Poppins-Light.otf';
import poppinsRegular from '../../assets/fonts/Poppins-Regular.otf';
import poppinsSemiBold from '../../assets/fonts/Poppins-SemiBold.otf';
/**
 * This helper injects the global styles specific to this project.
 *
 * In Short: 1) it sets the 'box-sizing' to 'border-box' for every element 2) it
 * sets Roboto as default font (with fallback to Helvetica) 3) it enables some
 * text smoothing things 4) it disables padding and margin on the body.
 */
const GlobalStyles = createGlobalStyle`
    html, body, div, span, applet, object, iframe,
    h1, h2, h3, h4, h5, h6, p, blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
        h1,
h2,
h3,
.titel,
.logo-text {
  font-family: 'Oswald', sans-serif;
}


    body {
    font-family: 'Poppins', sans-serif;
        margin: 0;
        padding: 0;
        height: 100%;
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
        font-smooth: always;
        -moz-osx-font-smoothing: grayscale;
        text-shadow: 0.0625rem 0.0625rem 0.0625rem rgba(0,0,0,.004);
        background-color: white;
        * {
            box-sizing: border-box;
            
            //font-family: 'Poppins';
            font-weight: normal;
        }

        p {
            line-height: 1.4em;
            margin-bottom: 10px;
        }
    }
`;

export default GlobalStyles;
